import { RefObject } from 'react';
import { useOnScreen } from '@belong/common';
import { IconAlert, IconArrowDown } from '@belong/icons';
import { ButtonBase, Text } from '@belong/ui';
import clsx from 'clsx';
import { customStyles } from 'containercomponents/MaintenanceStatus/MaintenanceAccountResponsibility/maintenance-account-responsibility.style';
import { maintenanceAccountResponsibilityStrings } from './maintenance-account-responsibility.constants';

const APPROVAL_COMPONENT_VISIBILITY_THRESHOLD = '-100px';

export const MaintenanceAccountResponsibilityBanner = ({
  componentRef,
}: {
  componentRef: RefObject<HTMLDivElement>;
}) => {
  const isApprovalComponentOnScreen = useOnScreen(
    componentRef,
    APPROVAL_COMPONENT_VISIBILITY_THRESHOLD,
  );

  const onBannerPress = () =>
    componentRef.current?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div
      className={clsx(
        'fixed inset-x-0 bottom-2xl z-10 flex translate-y-0 justify-center transition-transform duration-hover ease-in-out',
        isApprovalComponentOnScreen ? 'translate-y-7xl' : 'translate-y-0',
      )}
    >
      <ButtonBase
        onClick={onBannerPress}
        className="flex w-full items-center rounded-full bg-darker-navy px-sm py-2sm shadow-2xl"
        style={customStyles.bannerContainer}
      >
        <div className="flex flex-1 items-center justify-start">
          <IconAlert className="mr-xs text-red" height={24} />
          <Text fontWeight="semibold" className="text-white">
            {maintenanceAccountResponsibilityStrings.bannerAction}
          </Text>
        </div>

        <IconArrowDown height={20} />
      </ButtonBase>
    </div>
  );
};
